import React from "react";
import { Link } from "react-router-dom";
import herobanner  from "../assets/home/images/hero-banner.jpg";
import intimg1 from "../assets/home/images/interior-short-1.jpg"
import intimg2 from "../assets/home/images/interior-short-2.jpg";
import ltart from "../assets/home/images/latte-art.jpg";
import coffieclsup from "../assets/home/images/coffee-closeup.jpg";
import evevide from "../assets/home/images/evening-vibe.jpg";   
import  { Coffee } from "lucide-react";
import Menu from "./Menu";

const Home = () => {
  return (
    <main className="bg-neutral-50 text-gray-800">

      {/* Hero Section */}
      <section className="relative h-screen bg-black overflow-hidden">
  <div className="absolute inset-0 animate-zoom-slow">
    <img
      src={herobanner}
      alt="UrbanEdge Café"
      className="w-full h-full object-cover opacity-70"
    />
  </div>
  <div className="relative z-10 flex flex-col items-center justify-center h-full text-white text-center px-6">
    <h1 className="text-5xl md:text-6xl font-bold mb-4">Welcome to UrbanEdge Café</h1>
    <p className="text-xl md:text-2xl mb-8">Where every cup tells a story.</p>
    <Link to="/menu" className="bg-white text-black px-6 py-3 rounded-full hover:bg-amber-200 transition"
    >
      Explore Our Menu
    </Link>
  </div>
</section>

      {/* About Section */}
      <section className="py-16 px-6 max-w-6xl mx-auto grid md:grid-cols-2 gap-8 items-center">
        <img
          src={intimg1}
          alt="Urban Café Interior"
          className="rounded-2xl shadow-xl"
        />
        <div>
          <h2 className="text-3xl font-bold mb-4">A Cozy Urban Escape</h2>
          <p className="text-lg text-gray-700">
            Nestled in the heart of the city, UrbanEdge Café offers a tranquil setting
            with locally roasted coffee, artisan pastries, and a warm atmosphere.
          </p>
          <p className="mt-4 text-gray-600">
  Our baristas are artists in every pour, ensuring every cup brings joy.
</p>
<p className="mt-2 text-sm italic text-amber-800">UrbanEdge – Where Comfort Meets Craft.</p>

        </div>
      </section>

      {/* Feature Section */}
      <section className="py-16 bg-white px-6 max-w-6xl mx-auto grid md:grid-cols-3 gap-6">
        <div className="text-center">
            
          <img
            src={ltart}
            alt="Latte Art"
            className="rounded-xl mx-auto w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
          />
          <h3 className="mt-4 text-xl font-semibold">Signature Brews</h3>
          <p className="text-sm text-gray-600 mt-2">Crafted with precision and passion.</p>
        </div>

        <div className="text-center">
          <img
            src={coffieclsup}
            alt="Coffee Closeup"
            className="rounded-xl mx-auto w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
          />
          <h3 className="mt-4 text-xl font-semibold">Rich Aromas</h3>
          <p className="text-sm text-gray-600 mt-2">Sourced from the finest beans globally.</p>
        </div>

        <div className="text-center">
          <img
            src={intimg2}
            alt="Café View"
            className="rounded-xl mx-auto w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
          />
          <h3 className="mt-4 text-xl font-semibold">Atmosphere</h3>
          <p className="text-sm text-gray-600 mt-2">A perfect blend of modern and cozy.</p>
        </div>
      </section>

      {/* Evening Vibe Parallax Section */}
      <section
  className="relative bg-fixed bg-center bg-cover h-[80vh] flex items-center justify-center"
  style={{ backgroundImage: `url(${evevide})` }}
>
  <div className="bg-black bg-opacity-60 p-10 rounded-xl text-white text-center max-w-2xl">
    <h2 className="text-4xl font-bold mb-4">Unwind After Hours</h2>
    <p className="text-lg">Experience the warm glow, soft music, and comforting conversations at UrbanEdge Café by night.</p>
  </div>
</section>


      {/* Call to Action */}
      <section className="py-16 px-6 text-center bg-neutral-100">
        <h2 className="text-3xl font-bold mb-4">Ready to Visit?</h2>
        <p className="text-gray-600 text-lg mb-6">
          Book a table or just drop by. We're always brewing something special.
        </p>
        <Link
          to="/contact"
          className="inline-block bg-amber-500 hover:bg-amber-600 text-white font-semibold px-6 py-3 rounded-full transition"
        >
            
          Contact / Book Now
        </Link>
      </section>
    </main>
  );
};

export default Home;
